// Cached section geometry — offsetTop/height re-measured on resize and DOM
// growth (fonts/images), never per frame (no layout thrash in useFrame).
const metrics = new Map();
let observer;
let resizeHooked = false;

function measure(id) {
  const el = document.getElementById(id);
  if (!el) return;
  let top = 0;
  let node = el;
  while (node) {
    top += node.offsetTop;
    node = node.offsetParent;
  }
  metrics.set(id, { top, height: el.offsetHeight });
}

export function trackSections(ids) {
  ids.forEach(measure);
  if (!resizeHooked) {
    resizeHooked = true;
    window.addEventListener('resize', () => ids.forEach(measure), { passive: true });
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(() => ids.forEach(measure));
      observer.observe(document.body);
    }
    if (document.fonts?.ready) document.fonts.ready.then(() => ids.forEach(measure));
  }
  return () => {
    observer?.disconnect();
    observer = undefined;
    resizeHooked = false;
    metrics.clear();
  };
}

// Section center's distance from viewport center, in viewport-height units
// (0 = centered, negative = below the fold, positive = scrolled past).
export function sectionViewportOffset(id) {
  const m = metrics.get(id);
  if (!m) return -2;
  const vh = window.innerHeight || 1;
  return (window.scrollY + vh / 2 - (m.top + m.height / 2)) / vh;
}
